import { BaseQueryParams } from "../baseQuery";

export const priceRulesService = BaseQueryParams("priceRulesService", [
  "PriceRules",
]).injectEndpoints({
  endpoints: (builder) => ({
    getPriceRules: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/migrations/rules${page ? `?page=${page}` : ""}&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
      providesTags: () => ["PriceRules"],
    }),

    getRuleById: builder.query({
      query: (id) => ({
        url: `/admin/migrations/rule/${id}`,
        method: "GET",
      }),

      keepUnusedDataFor: 0,
      providesTags: () => ["PriceRules"],
    }),

    createPriceRule: builder.mutation({
      query: (body) => ({
        url: "/admin/migrations/rule",
        method: "POST",
        body,
      }),

      invalidatesTags: () => ["PriceRules"],
    }),

    updatePriceRule: builder.mutation({
      query: ({ id, body }) => ({
        url: `/admin/configurations/rules/${id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: () => ["PriceRules"],
    }),

    deletePriceRule: builder.mutation({
      query: (id) => ({
        url: `/admin/migrations/rule/${id}`,
        method: "Delete",
      }),

      invalidatesTags: () => ["PriceRules"],
    }),

    getUserEmails: builder.query({
      query: ({ email }) => ({
        url: `/migrations/wizard/get-accounts${
          email ? `?search=${encodeURIComponent(email)}` : ""
        }`,
        method: "GET",
      }),
    }),

    getRuleIntervals: builder.query({
      query: ({ page, filters }) => ({
        url: `/admin/configurations/interval-price?per_page=10&${
          page ? `page=${page}` : ""
        }&config=1`,
        method: "GET",
        params: filters,
      }),

      keepUnusedDataFor: 0,
      providesTags: () => ["PriceRules"],
    }),

    deleteRuleInterval: builder.mutation({
      query: (id) => ({
        url: `/admin/configurations/interval-price/${id}`,
        method: "Delete",
      }),

      invalidatesTags: () => ["PriceRules"],
    }),

    createRuleInterval: builder.mutation({
      query: (body) => ({
        url: "/admin/configurations/interval-price",
        method: "POST",
        body,
      }),

      invalidatesTags: () => ["PriceRules"],
    }),

    updateRuleInterval: builder.mutation({
      query: ({ id, body }) => ({
        url: `/admin/configurations/interval-price/${id}`,
        method: "PUT",
        body,
      }),

      invalidatesTags: () => ["PriceRules"],
    }),
  }),
});

export const {
  useGetPriceRulesQuery,
  useDeletePriceRuleMutation,
  useCreatePriceRuleMutation,
  useUpdatePriceRuleMutation,
  useGetRuleByIdQuery,
  useGetUserEmailsQuery,
  useGetRuleIntervalsQuery,
  useDeleteRuleIntervalMutation,
  useCreateRuleIntervalMutation,
  useUpdateRuleIntervalMutation,
} = priceRulesService;
